import { getSiteTheme } from './siteThemes';

/**
 * Betrun şemasının paketlenmiş görünümü (CSS + JS) hangi kurulumda çalışır.
 *
 * Görünüm marinabet105'in panelden yazdığı özel koddan alındı
 * (`themes/betrun/betrunSkin.css` / `betrunSkin.js`). Kendi özel CSS'i ya da
 * JS'i olan kurulum (marinabet105'in kendisi, backofficebetrun) bundan
 * **hiç etkilenmez** (16.10.2026, kullanıcı kararı): onların görünümü kendi
 * kodlarıdır ve üstüne ikinci bir katman binmesi — JS'te aynı menünün iki kez
 * kurulması, CSS'te yazmadıkları kuralların araya girmesi — sitelerini
 * değiştirirdi. Başlık/gövde/footer slotları sayılmaz: orada canlı destek ve
 * ölçüm kodu durur, görünüm değil.
 *
 * Karar `<html data-bhs-skin="betrun">` niteliğidir; paketlenmiş CSS'in her
 * seçicisi onu ister. Nitelik **açıkça verilir** (yokluğu "kapalı"dır): ayarlar
 * gelmeden önce özel kodlu bir kurulumda görünüm bir kare bile çizilmemelidir.
 * İlk boyamada titreme olmasın diye son karar tarayıcıda saklanır.
 */
export const SKIN_ATTRIBUTE = 'data-bhs-skin';
export const SKIN_VALUE = 'betrun';
const STORAGE_KEY = 'app:betrun-skin';

/**
 * Ayarlardan karar. ``null`` = karar verilemez (ayarlar gelmedi ya da hata
 * yolunda boş döndü) — bu durumda son bilinen karar korunur; boş bir yanıtı
 * "özel kodu yok" saymak özel kodlu siteye görünümü bindirirdi.
 */
export const skinEligible = (settings) => {
  if (!settings || !settings.site_theme) return null;
  if (getSiteTheme(settings.site_theme).id !== SKIN_VALUE) return false;
  const code = settings.custom_code;
  if (!code || typeof code !== 'object') return null;
  return !code.css_url && !code.js_url;
};

const root = () => (typeof document === 'undefined' ? null : document.documentElement);

export const applySkinFlag = (enabled) => {
  const el = root();
  if (!el) return;
  if (enabled) el.setAttribute(SKIN_ATTRIBUTE, SKIN_VALUE);
  else el.removeAttribute(SKIN_ATTRIBUTE);
};

/** Ayarlar geldiğinde: karar varsa uygular ve saklar. */
export const syncSkinFlag = (settings) => {
  const eligible = skinEligible(settings);
  if (eligible === null) return;
  applySkinFlag(eligible);
  try {
    if (eligible) window.localStorage.setItem(STORAGE_KEY, '1');
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch { /* depolama kapalıysa ilk boyama nitelik olmadan yapılır */ }
};

/** Uygulama açılırken: son bilinen kararı ilk boyamadan önce uygular. */
export const restoreSkinFlag = () => {
  try {
    applySkinFlag(window.localStorage.getItem(STORAGE_KEY) === '1');
  } catch {
    applySkinFlag(false);
  }
};
